<template>
    <div>
        <div class="current-quadrant">
            <div class="label">
                {{ $t('nBox.currentQuadrant') }}
            </div>
            <div class="title">
                {{ currentQuadrant.title }}
            </div>
        </div>
        <Quadrants
            :state="state"
            :disabled="disabled"
            :selected.sync="quadrant"
            :quadrants="allowedQuadrants"
            @change="onChangeSelectedQuadrant"
        />
    </div>
</template>
<script>
import Quadrants from '@/views/n-box/components/quadrant-calibration'
export default {
    components: {
        Quadrants,
    },
    props: {
        user: Object,
        state: Boolean,
        quadrants: Array,
        disabled: Boolean,
        currentQuadrant: Object,
        newXScore: [String, Number],
        newYScore: [String, Number],
    },
    data() {
        return {
            quadrant: null,
        }
    },
    computed: {
        allowedQuadrants() {
            return this.quadrants.filter(q => q.id != this.currentQuadrant.id)
        },
    },
    watch: {
        user() {
            this.quadrant = null
        },
    },
    methods: {
        onChangeSelectedQuadrant({ x, y }) {
            this.emitUpdateEvent('newXScore', x)
            this.emitUpdateEvent('newYScore', y)
        },
        emitUpdateEvent(prop, value) {
            this.$emit(`update:${prop}`, value)
        },
    },
}
</script>
<style lang="scss" scoped>
.current-quadrant {
    display: flex;
    align-items: center;
    text-align: center;
    flex-direction: column;
    justify-content: center;
    font-size: 14px;
    margin-bottom: 5px;

    .label {
        font-weight: 600;
        margin-bottom: 5px;
    }

    .title {
        width: 100%;
        padding: 5px;
        color: #6e6e6e;
    }
}
</style>
